// Etsy-style gallery arrows — added by Claude
(function () {
  function init() {
    var wrapper = document.querySelector('.product-gallery__carousel-wrapper');
    if (!wrapper || wrapper.querySelector('.etsy-gallery-arrow')) return;

    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__thumbnail'));
    if (thumbs.length < 2) return;

    function visibleThumbs() {
      return thumbs.filter(function (t) { return !t.classList.contains('is-filtered'); });
    }

    function go(dir) {
      var list = visibleThumbs();
      var idx = list.findIndex(function (t) { return t.classList.contains('is-nav-selected'); });
      if (idx === -1) idx = 0;
      var next = list[(idx + dir + list.length) % list.length];
      if (next) next.click();
    }

    function makeArrow(dir, cls, path, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'etsy-gallery-arrow etsy-gallery-arrow--' + cls;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="' + path + '"/></svg>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(dir); });
      wrapper.appendChild(b);
    }

    makeArrow(-1, 'prev', 'M15 18l-6-6 6-6', 'Previous image');
    makeArrow(1, 'next', 'M9 6l6 6-6 6', 'Next image');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
